import { render } from "./AdvisorEmailPreview.vue?vue&type=template&id=124157d4"
import script from "./AdvisorEmailPreview.vue?vue&type=script&lang=js"
export * from "./AdvisorEmailPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__